<app-header></app-header>
<div class="lesson-container mb-12">
  <app-course-sidebar></app-course-sidebar>

  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
